module.exports = __webpack_public_path__ + "img/388.3dfc6359.png";